import * as React from 'react';

// components
import { CookieNotice, Footer, Header } from '../../components';

// styles
import * as styles from './MainTemplate.sass';

interface IProps {
  className?: string;
}

export const MainTemplate: React.SFC<IProps> = ({ children }) => (
  <div className={styles.container}>
    <Header />
    <div>{children}</div>
    <Footer />
    <CookieNotice />
  </div>
);
